/** Chemins de navigation de l'objet Catégorie d'article (fiche par objet sur route). */

/** Base de la page "Configuration comptabilité". */
export const ARTICLE_CATEGORY_ADMIN_BASE = '/admin/configuration-comptabilite';

/** Onglet du dashboard correspondant au listing des catégories d'articles. */
export const ARTICLE_CATEGORY_TAB = 'categorieArticle';

/** Listing des catégories d'articles (onglet du dashboard comptabilité). */
export const articleCategoryListPath = `${ARTICLE_CATEGORY_ADMIN_BASE}?tab=${ARTICLE_CATEGORY_TAB}`;

/** Fiche de création d'une catégorie d'article. */
export const articleCategoryCreatePath = `${ARTICLE_CATEGORY_ADMIN_BASE}/categorie-article/new`;

/** Fiche d'édition d'une catégorie d'article. */
export const articleCategoryFichePath = (id: string | number): string =>
    `${ARTICLE_CATEGORY_ADMIN_BASE}/categorie-article/${id}`;

/** Route enfant (relative à `admin/configuration-comptabilite`) : création (`new`) et édition (`:id`). */
export const ARTICLE_CATEGORY_FICHE_ROUTE = 'categorie-article/:id';
